// this entry point requires the following peer dependencies: @wix/dashboard
export { WixPatternsProviderInternal as CairoProvider } from '../../dashboard/WixPatternsProviderInternal';
export { WixPatternsProviderProps as CairoProviderProps } from '../../dashboard/WixPatternsDashboardBaseProvider';
